import { render, staticRenderFns } from "./report-manager.vue?vue&type=template&id=88374374&scoped=true&"
import script from "./report-manager.vue?vue&type=script&lang=js&"
export * from "./report-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88374374",
  null
  
)

export default component.exports